export const getTimeAsPercentageOfDay = (time, day) => {
    if (time.isBefore(day))
        return 0;
    if (time.isAfter(day.endOf('day')))
        return 100;
    return (time.diff(time.startOf('day'), 'minutes') / 1440) * 100;
};
